import { Box, Button } from '@mui/material';
import React, { FC } from 'react';
import TimelineSection, { TimelineItem } from 'components/TimelineSection';

interface SalesCallTimelineSectionProps {
  items: TimelineItem[];
  emptyText: string;
  showStatus?: boolean;
  onAddClick: () => void;
  addButtonText: string;
}

const SalesCallTimelineSection: FC<SalesCallTimelineSectionProps> = ({
  items,
  emptyText,
  showStatus = false,
  onAddClick,
  addButtonText,
}) => {
  return (
    <Box>
      <Box sx={{ mb: 2, display: 'flex', justifyContent: 'flex-start' }}>
        <Button variant="outlined" size="small" onClick={onAddClick} sx={{ textTransform: 'capitalize' }}>
          {addButtonText}
        </Button>
      </Box>
      <TimelineSection items={items} emptyText={emptyText} showStatus={showStatus} />
    </Box>
  );
};

export default SalesCallTimelineSection;


